import { render, staticRenderFns } from "./SidebarNavItem.vue?vue&type=template&id=522acce5&scoped=true"
import script from "./SidebarNavItem.ts?vue&type=script&lang=ts&external"
export * from "./SidebarNavItem.ts?vue&type=script&lang=ts&external"
import style0 from "./SidebarNavItem.vue?vue&type=style&index=0&id=522acce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522acce5",
  null
  
)

export default component.exports